document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');

  if (!header) {
    console.warn('⚠️ No se encontró el header con id="header"');
    return;
  }

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('header-scrolled');
    } else {
      header.classList.remove('header-scrolled');
    }
  });
});
